import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Classification } from '../../../model/attr/classification';
import { NecClassificationSelectService } from './classification-select.service';
import { NecClassificationService } from '../classification.service';
import { NecMultiSelectData } from '../../selects/multi-select/multi-select-data';
import { SelectedInfo } from '../../selects/multi-select/selected-info';

@Component({
  selector: 'nec-classification-select',
  templateUrl: './classification-select.component.html',
  styleUrls: ['./classification-select.component.scss'],
  providers: [NecClassificationSelectService]
})
export class NecClassificationSelectComponent implements OnInit {
  @Input() classificationIds: number[] = [];
  @Output() selectChange: EventEmitter<Classification[]> = new EventEmitter();
  classifications: Classification[] = [];
  multiSelectData: NecMultiSelectData = {selectItems: [], defaultLabelHead: 'ç­é', defaultLabelContent: 'æ´å¤'};
  selectedValues: string[] = [];
  constructor(private cfc: NecClassificationService,
              private classificationSelectService: NecClassificationSelectService) {
  }

  ngOnInit() {
    this.cfc.getClassifications().subscribe((resp: Classification[]) => {
      this.classifications = resp;
      this.classificationSelectService.setMultiSelectData(this.classifications, this.multiSelectData);
      this.selectedValues = this.classificationSelectService.getSelectedValues(this.multiSelectData, this.classificationIds);
    });
  }

  targetChanged(info: SelectedInfo) {
    if (!info.changeItem) {
      this.selectChange.emit([]);
      return;
    }
    let ids = info.selectedItems.map(item => +item);
    this.selectChange.emit(this.classificationSelectService.getSelectedClassification(this.classifications, ids));
  }
}
